import React from "react";
import "./footer.css"; // Import the CSS file
import logo from "../../assets/BannerSection/agentinstruct-logo-elixirclaw-black.svg";
const FooterSection = () => {
  return (
    <footer>
      <div className="footer__wrapper">
        <div className="container">
          <div className="footer-inner">
            <div className="footer-items">
              <div className="footer-logo">
                <img src={logo} alt="AgentInstruct logo" />
              </div>
              <div className="row">
                <div className="list-name">
                  <p>
                    Empower Your Team with Agentic AI Leverage AgentInstruct’s
                    Agentic AI-driven insights and automated recommendations to
                    make smarter, faster decisions across your data sources.
                  </p>
                </div>
              </div>
            </div>
            <div className="footer-end">
              <div className="row" style={{ alignItems: "center" }}>
                <div className="col-sm-7 col-md-7 col-lg-7">
                  <div className="footer-links">
                    <p>Legal</p>
                    <p>Privacy Policy</p>
                    <p>Terms & Conditions</p>
                  </div>
                </div>
                <div className="col-sm-5 col-md-5 col-lg-5 copyright">
                  <p>Copyright 2026. All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
